import React, { createContext, useContext, useReducer } from "react";
export const SettingsContext = createContext();
export const SettingsProvider = ({ reducer, initialState, children }) => (
  <SettingsContext.Provider value={useReducer(reducer, initialState)}>
    {children}
  </SettingsContext.Provider>
);
export const SettingsConsumer = () => useContext(SettingsContext);
